module.exports = {"TXTCLI_Contact_Support":{"id":"TXTCLI_Contact_Support","defaultMessage":"Зв''язатись зі службою підтримки","track":"Contact Support"}}